import React from 'react';
import { AlertModal, Dropdown, useModalContext } from '@fourthwall/components';
import { SubscriptionCancelModal } from '../SubscriptionCancelModal';
export const SubscriptionCancel = ({ member, onSuccess }) => {
    const modal = useModalContext();
    const cancelSubscription = () => {
        if (member.cancelRequest.type === 'Allowed') {
            modal.open(SubscriptionCancelModal, {
                member,
                onSuccess,
            });
        }
        else {
            let text = '';
            if (member.cancelRequest.reason === 'AlreadyRequested') {
                text =
                    'Subscription cancellation has already been requested. Please allow up to a minute for changes to show on this page.';
            }
            if (member.cancelRequest.reason === 'IapSubscription') {
                text =
                    'Subscriptions managed through the Apple App Store and Google Play Store cannot be canceled here. Please ask your supporter to cancel the subscription on their device.';
            }
            modal.open(AlertModal, {
                title: 'Cancel unavailable',
                text,
                size: 'small',
            });
        }
    };
    if (member.cancelRequest.type === 'Disabled' &&
        member.cancelRequest.reason === 'SubscriptionNotActive')
        return null;
    return React.createElement(Dropdown.Item, { label: "Cancel subscription", onClick: cancelSubscription });
};
